import { styled } from "styled-components";

import { CopyLinkField } from "common/components/CopyLinkField";
import { Separator } from "common/components/Separator";
import type { Setter } from "common/types/setter";
import { useTranslate } from "common/utilities/useTranslate";
import { CollectionUpdatePermissions } from "domains/collection/components/edit/parts/CollectionUpdatePermissions";
import type { Permissions } from "domains/collection/components/edit/types/permissions";

const StyledHeading = styled.div`
  color: ${({ theme }) => theme.colors.textBright};
  font-weight: bold;
`;

const StyledCopyLinkField = styled(CopyLinkField)`
  flex: 0;
  margin: 0;
`;

type PermissionSettingsTabProps = { id?: string; permissions: Permissions; setPermissions: Setter<Permissions> };

export const PermissionSettingsTab = ({ id, permissions, setPermissions }: PermissionSettingsTabProps) => {
  const translate = useTranslate();

  return (
    <>
      <CollectionUpdatePermissions permissions={permissions} setPermissions={setPermissions} />
      {id && (
        <>
          <Separator />
          <StyledHeading>{translate("app.create.collection.public_access")}</StyledHeading>
          <StyledCopyLinkField
            isDisabled={!permissions.isPublic}
            url={`${import.meta.env.VITE_WEBSITE_URL}/collection/${id}`}
          />
        </>
      )}
    </>
  );
};
